import { managedFetch } from 'query/fetch';
export const cleanPathForFilename = (path: string, subcategory?: number): string => {
    let result = path
        .replace(/^\//, "") // Remove leading slash
        .replace(/[\/:*?"<>|]/g, "_") // Replace invalid filename characters
        .replace(/\s+/g, "_") // Replace spaces with underscores
        .replace(/_+/g, "_") // Replace multiple underscores with a single one
        .trim(); // Trim any leading/trailing whitespace

    //TODO: check the category code and match the subcategory
    if (result == 'activities_utilities_dashboard') {
        switch (subcategory) {
            case 0: result += "-electricity";
                break;
            case 1: result += "-gas";
                break;
            case 2: result += "-water";
                break;
            case 3: result += "-heating";
                break;
            case 4: result += "-cooling";
                break;
            case 5: result += "-steam";
                break;
        }
    }
    return result;
};

export const dataUrlToFile = async (dataUrl: string, filename = 'signature.png'): Promise<File> => {
    const blob = await managedFetch(dataUrl, undefined, response => response.blob());
    return new File([blob], filename, { type: blob.type || 'image/png' });
};

/** The request layer returns `response.data`, so file URL may be nested. */
export const extractFileUrlFromApiResponse = (body: unknown): string | null => {
    if (!body || typeof body !== 'object') {
        return null;
    }

    const payload = body as Record<string, unknown>;
    const nestedData = payload.data;
    const url =
        (nestedData && typeof nestedData === 'object'
            ? (nestedData as Record<string, unknown>).file_url
            : undefined) ??
        payload.file_url ??
        (nestedData &&
        typeof nestedData === 'object' &&
        (nestedData as Record<string, unknown>).data &&
        typeof (nestedData as Record<string, unknown>).data === 'object'
            ? ((nestedData as Record<string, unknown>).data as Record<string, unknown>).file_url
            : undefined);

    return typeof url === 'string' && url.trim() !== '' ? url : null;
};

/** With `responseType: 'blob'`, the interceptor may return the Blob directly. */
export const resolveBlobFromApiResponse = (payload: unknown): Blob | null => {
    const raw =
        payload instanceof Blob
            ? payload
            : payload &&
                typeof payload === 'object' &&
                (payload as { data?: unknown }).data instanceof Blob
              ? ((payload as { data: Blob }).data)
              : null;

    if (!raw || typeof raw.size !== 'number' || raw.size <= 0) {
        return null;
    }

    return raw;
};